import { JUNIOR_AGE, MOBILE_APPS } from 'constants/common';

import { LOCALES_WITH_TEEN_APP } from '@albert/shared/constants';
import type { Locale } from '@albert/shared/types';

export const getProductTypeByAge = (age: number, locale: Locale) => {
  if (!LOCALES_WITH_TEEN_APP.includes(locale)) return MOBILE_APPS.JUNIOR;
  return age <= JUNIOR_AGE ? MOBILE_APPS.JUNIOR : MOBILE_APPS.TEEN;
};
